export default __webpack_public_path__ + "static/media/plusIcon.1b54a862.svg";